import React, { Component } from "react";
import { inject, observer } from "mobx-react";

import { Button, CircularProgress } from "@material-ui/core";

import "./auth/AuthPages.css";

import { withRouter, Link } from "react-router-dom";
import queryString from "query-string";
import Cookies from 'universal-cookie';

import WarningModal from "../components/modal/WarningModal";
import logo from "../img/hotgig-logo.png";
import backgroundImage from "../img/background-images-2025.jpg";
const cookies = new Cookies();
const IS_MOBILE = process.env.REACT_APP_IS_MOBILE === "true";
const EMAIL_CONFIRMATION_REQUIRED = process.env.REACT_APP_EMAIL_CONFIRMATION_REQUIRED === "true";
const BASE_URL = process.env.REACT_APP_BASE_URL;

@inject("userStore", "authStore", "profileStore", "facebookStore", "billingStore", "commonStore")
@withRouter
@observer
class Login extends Component {
    state = {
        source: undefined,
        checked: false,
        isLoading: false,
        showPassword: false,
        isEmailInvalid: false
    };

    constructor(props) {
        super(props);
        this.props.authStore.reset();
    }

    componentDidMount() {
        let params = queryString.parse(this.props.location.search);

        const emailConfirmation = localStorage.getItem("email-confirmation")
        if (emailConfirmation) {
            this.props.authStore.setEmail(emailConfirmation);
        }
        if (params.email) {
            this.props.authStore.setEmail(params.email);
        }

        if (params.token && params.refreshToken) {
            this.props.authStore.loginWithToken(params.token, params.refreshToken).then(() => {
                if (params.redirectUrl) {
                    this.props.history.push(params.redirectUrl);
                }
            });
        }
        var rememberMe = false
        var emailLogin = cookies.get('emailLogin')
        if (emailLogin) {
            this.props.authStore.setEmail(emailLogin);
            rememberMe = true
        }
        var passwordLogin = cookies.get('passwordLogin')
        if (passwordLogin) {
            this.props.authStore.setPassword(passwordLogin);
            rememberMe = true
        }
        if (params.source) {
            this.setState({
                source: params.source,
                checked: rememberMe
            });
            this.props.authStore.setSource(params.source);
        } else {
            this.setState({ checked: rememberMe })
        }
    }

    handleCheckBox = (e) => {
        this.setState({ checked: e.target.checked })
    }

    handleTextCheckBox = () => {
        this.setState({ checked: !this.state.checked })
    }
    handleEmailChange = e => this.props.authStore.setEmail(e.target.value);
    handleValidateEmail = e => this.props.authStore.validateEmail(e.target.value);
    handlePasswordChange = e => this.props.authStore.setPassword(e.target.value)
    handleValidatePassword = e => this.props.authStore.validatePassword(e.target.value)

    openModal = () => {
        this.setState({ isEmailInvalid: true })
    }
    closeModal = () => {
        this.setState({ isEmailInvalid: false })
    }

    anyError(field) {
        if (!this.props.authStore.errors) return false;
        if (!this.props.authStore.errors[field]) return false;
        return true;
    }

    openSignupLink = () => {
        window.cordova.InAppBrowser.open(`${BASE_URL}register`, "_system", "location=yes");
    };

    errorText(field) {
        if (!this.props.authStore.errors) return null;
        if (!this.props.authStore.errors[field]) return null;
        return this.props.authStore.errors[field];
    }

    handleSubmitForm = async (e) => {
        e.preventDefault();
        this.props.commonStore.resetAllData();
        this.setState({ isLoading: true })
        this.props.authStore.checkEmailValid().then(async (isValid) => {
            if (isValid || process.env.REACT_APP_DISABLE_DISPOSABLE_EMAIL === "false") {
                this.props.authStore.login().then(async result => {
                    this.setState({ isLoading: false })
                    if (this.state.checked) {
                        cookies.set('emailLogin', this.props.authStore.values.email, { path: '/' });
                        cookies.set('passwordLogin', this.props.authStore.values.password, { path: '/' });
                    } else {
                        cookies.remove('emailLogin', { path: '/' });
                        cookies.remove('passwordLogin', { path: '/' });
                    }
                    const { redirectUrl } = this.props.authStore;
                    const { currentUser } = this.props.userStore;
                    const { profile } = this.props.profileStore;
                    if (!this.props.userStore.isUserVerified()) {
                        this.props.history.push("/confirmation");
                    }

                    if (currentUser.status !== 50 || profile === undefined) {
                        if (!this.props.userStore.isUserVerified() && EMAIL_CONFIRMATION_REQUIRED) {
                            this.props.history.push("/confirmation");
                        } else if (Number.isNaN(currentUser.status)) {
                            this.gotoDashboard(profile.type)
                        } else {
                            this.props.history.push("/welcome");
                        }
                    } else if (redirectUrl) {
                        this.props.history.push(redirectUrl);
                    } else {
                        this.gotoDashboard(profile.type)
                    }
                }).finally(() => {
                    this.setState({ isLoading: false })
                });
            } else {
                this.setState({ isLoading: false })
                this.openModal()
            }
        })
    };

    handleClickShowPassword = () => {
        const { showPassword } = this.state
        this.setState({ showPassword: !showPassword })
    }

    gotoDashboard(profileType) {
        switch (profileType) {
            case 1:
                this.props.history.push("/musician");
                break;
            case 2:
                this.props.history.push("/agent");
                break;
            case 3:
                this.props.history.push("/staff");
                break;
            case 6:
                this.props.history.push("/production");
                break;
            case 7:
                this.props.history.push("/dj");
                break;
            case 8:
                this.props.history.push("/agent");
                break;
            case 9:
                this.props.history.push("/privatehire/gig");
                break;
            default:
                this.props.history.push("/welcome");
                break;
        }
    }

    render() {
        const { values } = this.props.authStore;
        const { isLoading, showPassword } = this.state;

        return (
            <div className="auth-page" style={{ backgroundImage: `url(${backgroundImage})` }}>
                <div className="auth-container">
                    <div className="auth-card">
                        <div className="auth-header">
                            <div className="auth-logo">
                                <img src={logo} alt="Hot Giggity" className="auth-logo-img" />
                            </div>
                        </div>

                        <div className="auth-content">
                            <h1 className="auth-title">Welcome back!</h1>
                            <p className="auth-subtitle">Sign in to continue to your account</p>

                            <form className="auth-form" onSubmit={this.handleSubmitForm}>
                                {this.anyError("general") && (
                                    <div className="auth-error-message">
                                        {this.errorText("general")}
                                    </div>
                                )}

                                <div className="auth-form-group">
                                    <label htmlFor="email">Email Address</label>
                                    <div className="auth-input-wrapper">
                                        <svg className="auth-input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                            <rect x="3" y="5" width="18" height="14" rx="2"></rect>
                                            <polyline points="3 7 12 13 21 7"></polyline>
                                        </svg>
                                        <input
                                            id="email"
                                            placeholder="Enter your email"
                                            type="email"
                                            value={values.email}
                                            onChange={this.handleEmailChange}
                                            onBlur={this.handleValidateEmail}
                                            className={this.anyError("email") ? "auth-input-error" : ""}
                                        />
                                        {this.anyError("email") && <span className="auth-error-text">{this.errorText("email")}</span>}
                                    </div>
                                </div>

                                <div className="auth-form-group">
                                    <label htmlFor="password">Password</label>
                                    <div className="auth-input-wrapper">
                                        <svg className="auth-input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                                            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                                        </svg>
                                        <input
                                            id="password"
                                            type={showPassword ? 'text' : 'password'}
                                            placeholder="Enter your password"
                                            value={values.password}
                                            onChange={this.handlePasswordChange}
                                            onBlur={this.handleValidatePassword}
                                            className={this.anyError("password") ? "auth-input-error" : ""}
                                        />
                                        <button
                                            type="button"
                                            className="auth-password-toggle"
                                            aria-label="toggle password visibility"
                                            onClick={this.handleClickShowPassword}
                                        >
                                            {showPassword ? (
                                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                                                    <circle cx="12" cy="12" r="3"></circle>
                                                </svg>
                                            ) : (
                                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                                                    <line x1="1" y1="1" x2="23" y2="23"></line>
                                                </svg>
                                            )}
                                        </button>
                                        {this.anyError("password") && <span className="auth-error-text">{this.errorText("password")}</span>}
                                    </div>
                                </div>

                                <div className="auth-form-options">
                                    <label className="auth-checkbox-wrapper">
                                        <input
                                            type="checkbox"
                                            checked={this.state.checked}
                                            onChange={this.handleCheckBox}
                                            className="auth-custom-checkbox"
                                        />
                                        <span className="auth-checkbox-box"></span>
                                        <span className="auth-checkbox-label">Remember me</span>
                                    </label>
                                    <Link to="/forgotpassword" className="auth-forgot-link">Forgot password?</Link>
                                </div>

                                {isLoading ? (
                                    <div className="auth-loading">
                                        <CircularProgress />
                                    </div>
                                ) : (
                                    <Button className="auth-btn-primary" variant="contained" type="submit">
                                        <span>Sign In</span>
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <line x1="5" y1="12" x2="19" y2="12"></line>
                                            <polyline points="12 5 19 12 12 19"></polyline>
                                        </svg>
                                    </Button>
                                )}
                            </form>

                            <div className="auth-footer">
                                <p>Don't have an account? <Link to="/sign-up">Create one now</Link></p>
                            </div>
                        </div>
                    </div>

                    <div className="auth-promo">
                        <div className="promo-content">
                            <div className="promo-icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
                                    <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                                    <line x1="12" y1="19" x2="12" y2="23"></line>
                                    <line x1="8" y1="23" x2="16" y2="23"></line>
                                </svg>
                            </div>
                            <h2>The Platform for Live Entertainment</h2>
                            <p>Connecting musicians, venues, agents, and event organisers. Manage bookings, invoices, and payments all in one place.</p>
                            <ul className="promo-features">
                                <li>
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span>Streamlined booking process</span>
                                </li>
                                <li>
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span>Integrated invoicing</span>
                                </li>
                                <li>
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span>Global network</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <WarningModal
                    title={"Warning: Temporary Email Address Detected"}
                    open={this.state.isEmailInvalid}
                    message={`<p>We have detected that you are trying to sign into an account created using a temporary email address. Our platform now requires a verifiable email address for registration to ensure the security and reliability of our services.</p>
                    <p>If you are the legitimate owner of this account, please contact our support team at support@hotgiggity.com.</p>`}
                    closeHandler={this.closeModal}
                    confirmationLabel="Ok"
                />
            </div>
        );
    }
}

export default Login;
